
    <div class="container" style="padding-top: 13px;">
        <div class="d-flex">
            <div class="col-4">
                <img src="assets/img/backMenu.svg" alt="" (click)="gotoRestoPage()" style="cursor: pointer;">
            </div>
            <div class="col-6">
                <p class="location">Your Location</p>
            </div>
        </div>
    </div>

<div class="blankLine">
    &nbsp;
</div>

<div class="container">
    <div class="searchbar">
        <div style="margin-top: -4px;">
            <span style="padding-left: 10px;"><img src="assets/img/SearchIcon.svg" alt=""></span>
        </div>
        <div>
            <!-- (ngSubmit)="onSubmit(myForm.valid)" -->
            <form [formGroup]="myForm" novalidate>
                <input placeholder="Search a new address..." autocorrect="off" autocapitalize="off" spellcheck="off"
                    type="text" class="inptext" #city formControlName="city"
                    (ngModelChange)="modelChanged($event,city)">
            </form>
        </div>
        <div>
            <span><img src="assets/img/closeNew.svg" alt="" (click)="clearValue()" *ngIf="showFilteredResto"></span>
        </div>

    </div>
</div>

<div class="container">
    <div class="d-flex marg-t6">
        <div style="margin-left: 11px;">
            <img src="../../../../assets/img/user-location.svg" alt="">
        </div>
        <div style="padding-left: 12px">
            <div class="location-text">Current location</div>
            <div class="d-flex">
                <div class="loc-text">
                    Enable your current location for better services
                </div>
                <div>
                    <button type="button" class="btn-enable" (click)="enableCurrentLocation()">Enable</button>
                </div>

            </div>
        </div>
    </div>
</div>